// extracted by mini-css-extract-plugin
module.exports = {"container":"main-router_container__kI-wW","content":"main-router_content__1LDnx","contentWithSidebar":"main-router_contentWithSidebar__2qm-Q"};